import { Ubicacion } from '@/domain/entities/ubicacion';
import { IUbicacionRepository } from '@/domain/repositories';

export class GetUbicacionByIdUseCase {
  constructor(
    private readonly repository: IUbicacionRepository
  ) {}

  async execute(id: string): Promise<Ubicacion> {
    return this.repository.findById(id);
  }
}
